import { memo } from "react";
import { useJobCounter } from "../../hooks/useJobCounter";

const JobCounter = memo(() => {
  const count = useJobCounter();

  if (!count) return null;

  return (
    <span
      className=" relative z-10 flex justify-center items-center size-5 rounded-full text-white bg-red-600 text-xs font-medium animate-pulse "
    >
      <span className="absolute inset-0 rounded-full bg-red-400 opacity-75 " />
      <span className=" z-10">{count}</span>
    </span>
  );
});

export default JobCounter;
